import React from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { hideModal } from "../../../store/modal/actions";

const AleartMessage = () => {
  const openModal = useSelector((state) => state.modal.open);
  const type = useSelector((state) => state.modal.type);
  const description = useSelector((state) => state.modal.description);
  const onSubmit = useSelector((state) => state.modal.onSubmit);

  const handleOk = () => {
    if (onSubmit) {
      onSubmit();
    }
    hideModal();
  };

  const handleCancel = () => {
    hideModal();
  };

  return (
    <Modal
      title={type}
      open={openModal}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={"YES"}
      cancelText={"CANCEL"}
      width={350}
    >
      <p>{description}</p>
    </Modal>
  );
};

export default AleartMessage;
